import { useMap } from "@vis.gl/react-google-maps";
import { Button, Form } from "antd";
import { FormInstance } from "antd/es/form/hooks/useForm";
import React, { useMemo } from 'react';
import { MAP_ELEMENT } from "../../../contexts/WorldMapContext/constants";
import GoogleMap from "../../../contexts/WorldMapContext/GoogleMap";
import { markerByName } from "../../../contexts/WorldMapContext/Marker";
import { isEmpty } from "../../../util/varibles/global";

interface IProps {
    form: FormInstance
    locationType: MAP_ELEMENT
}

const Map: React.FC<IProps> = ({ form, locationType }) => {
    const map = useMap('map');
    const workTime = Form.useWatch('work_time', form);
    const name = Form.useWatch('name', form);
    const { latitude = '', longitude = '' } = Form.useWatch('position', form) || {};
    const isLocation = !isEmpty(latitude) && !isEmpty(longitude);
    const mapCenter = useMemo(() => isLocation
        ? { lat: +latitude, lng: +longitude }
        : undefined, [isLocation, latitude, longitude]);

    const Marker = markerByName[locationType];

    return <>
        <div className='h-full w-full'>
            <GoogleMap
                center={mapCenter}
                onContextmenu={e => {
                    if (e) {
                        const { lat = 0, lng = 0 } = e.detail.latLng || {};
                        const position = { latitude: lat, longitude: lng }
                        form.setFieldsValue({ position });
                    }
                }}
            >
                {Marker && <Marker
                    data={{
                        id: 'POI',
                        name,
                        work_time: workTime * 60,
                        position: isLocation ? { latitude, longitude } : undefined
                    }}
                />}
            </GoogleMap>
        </div>
        <div className="absolute top-1 right-1">
            <Button
                className="bt-primary"
                disabled={!isLocation}
                onClick={() => mapCenter && map?.panTo(mapCenter)}
            >
                Center
            </Button>
        </div>
    </>;
};

export default Map;
